/**
 * @generated SignedSource<<1516d858481a940b9a419487ead65c28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CountryEditTabs_country$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CountryEditMain_country" | "CountryEditRegions_country" | "MediaEditor_mediable" | "SeoTab_seoable">;
  readonly " $fragmentType": "CountryEditTabs_country";
};
export type CountryEditTabs_country$key = {
  readonly " $data"?: CountryEditTabs_country$data;
  readonly " $fragmentSpreads": FragmentRefs<"CountryEditTabs_country">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CountryEditTabs_country",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CountryEditMain_country"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CountryEditRegions_country"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MediaEditor_mediable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoTab_seoable"
    }
  ],
  "type": "Country",
  "abstractKey": null
};

(node as any).hash = "cbd9c8035ce2b946e3340a428ce84c37";

export default node;
